/**
 * Content-Design-authored copy for the Declaration route (H2 Screen 6),
 * rewritten for TG-6 (AC-20) from the retired H1 copy this module used to
 * carry (`docs/.../screens/declaration.md`, `m1-portal-routing-resume-
 * model`'s own TG-7). Every string below is taken byte-for-byte from
 * `docs/Final_Prototype_M1/.../design_handoff_renewals_portal_H2/screens/
 * 06-Declaration.dc.html`, the approved H2 handoff (NFR-gag78j: the
 * declaration statement and compensation disclosure are FRP's licensed
 * wording, shown unaltered).
 *
 * Field-validation error strings are NOT duplicated here — they live once,
 * in src/web/src/validation/error-registry.ts (ADR-20260918-htmd), and
 * DeclarationRoute.tsx reads them from there directly.
 */
export const declarationContent = {
  eyebrow: "Step 3 of 3",
  heading: "Declaration",
  intro: "Please review the statement below and provide your signature to submit your renewal.",
  backLabel: "Back to review your exposures",
  statementHeading: "Declaration statement",
  statement:
    "I certify that I have reviewed the information provided and that it is true, correct, and complete to the best of my knowledge. I understand that it is my responsibility to promptly notify Foundation Risk Partners of any changes, additions, or corrections to this information, including any material changes that may affect insurance coverage, underwriting, or premium calculations. I acknowledge that coverage may be based upon the accuracy of the information provided.",
  acknowledgementLabel: "I have read and agree to this declaration",
  representativeNameLabel: "Authorized representative",
  representativeNameHelp: "Full name of person submitting the renewal",
  dateLabel: "Date:",
  disclosureHeading: "Compensation disclosure",
  disclosureParagraphs: [
    "Foundation Risk Partners (FRP) Agencies are licensed insurance producers in the states where we conduct business, which includes the sale, solicitation, and servicing of insurance policies. Our agencies receive compensation from insurers in the form of commissions, which are based on a percentage of the premiums due to the applicable insurance companies. In addition, we may receive other forms of compensation, such as contingent commissions, depending upon state regulations and the role our agency is fulfilling.",
    "Should you have any questions about the compensation we receive from your policies — whether active or proposed — please feel free to contact your FRP representative. We greatly appreciate the opportunity to serve you and thank you for your continued trust in our services.",
  ],
  submitLabel: "Submit renewal",
  saveAndFinishLaterLabel: "Save and finish later",
  helpLine: "Need help? Contact your Account Manager.",
} as const;
